import { Star, Meteor, Eclipse, Sparkles } from "lucide-react";

const getEventIcon = (type) => {
  switch (type) {
    case "meteor_shower":
      return <Sparkles className="w-5 h-5 text-amber-400" strokeWidth={1.5} />;
    case "eclipse":
      return <Eclipse className="w-5 h-5 text-orange-400" strokeWidth={1.5} />;
    case "starlink":
      return <Star className="w-5 h-5 text-cosmic-blue" strokeWidth={1.5} />;
    default:
      return <Star className="w-5 h-5 text-starlight" strokeWidth={1.5} />;
  }
};

const getEventBg = (type) => {
  switch (type) {
    case "meteor_shower":
      return "bg-amber-500/20";
    case "eclipse":
      return "bg-orange-500/20";
    case "starlink":
      return "bg-cosmic-blue/20";
    default:
      return "bg-white/10";
  }
};

export const SkyEventsWidget = ({ events }) => {
  if (!events || events.length === 0) return null;

  return (
    <div className="glass-card p-6" data-testid="sky-events-widget">
      <h3 className="section-title mb-4">Sky Events</h3>
      
      <div className="space-y-3">
        {events.slice(0, 5).map((event) => (
          <div
            key={event.id}
            className="glass-card-hover p-4"
            data-testid={`sky-event-${event.id}`}
          >
            <div className="flex items-start gap-3">
              <div className={`p-2 rounded-lg ${getEventBg(event.type)}`}>
                {getEventIcon(event.type)}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2 mb-1">
                  <h4 className="font-heading font-semibold text-white">
                    {event.name}
                  </h4>
                  <span className="text-xs text-slate-500 font-mono whitespace-nowrap">
                    {event.peak_date}
                  </span>
                </div>
                <p className="text-sm text-slate-400 line-clamp-2">
                  {event.description}
                </p>
                <p className="text-xs text-cosmic-blue mt-1">{event.visibility}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const SkyEventsWidgetSkeleton = () => (
  <div className="glass-card p-6">
    <div className="skeleton h-6 w-32 rounded mb-4" />
    <div className="space-y-3">
      {[1, 2, 3].map((i) => (
        <div key={i} className="glass-card p-4">
          <div className="flex items-start gap-3">
            <div className="skeleton w-10 h-10 rounded-lg" />
            <div className="flex-1 space-y-2">
              <div className="skeleton h-5 w-3/4 rounded" />
              <div className="skeleton h-4 w-full rounded" />
              <div className="skeleton h-3 w-1/2 rounded" />
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);
